import BoardPackPanel from "@/components/risk/BoardPackPanel";
export default function PBoard() { return <BoardPackPanel range="P" />; }
